import create, { StateCreator, StoreApi } from "zustand";
import configService from "@services/config.service";
import _ from "lodash";

interface IConfigStore {
  accessLevel: string;
  canEdit: () => boolean;
  config: any;
  loader: boolean;
  isMemberListPresent : boolean;
  fetchConfig: () => Promise<void>;
  setConfigValues: (configList: any, role: string, accessLevel: string) => void;
  clearStore: () => void;
}

let store: StateCreator<IConfigStore, [], [], IConfigStore> | StoreApi<IConfigStore> = (set, get) => ({
  accessLevel: "",
  canEdit: function () {
    let store = get();
    return store.accessLevel.includes("W");
  },
  config: null,
  loader: true,
  isMemberListPresent : false,
  fetchConfig: async () => {
    set(() => ({ loader: true }));
    configService.getAppConfig().subscribe({
      next: (v) => {
        get().setConfigValues(v.data.data?.[0]?.configOptions, v.data.data?.[0]?.role, v.data.data?.[0]?.accessLevel || "")},
      error: (e) => {
        set(() => ({ loader: false }));
      },
      complete: () => set(() => ({ loader: false })),
    });
  },
  setConfigValues: (configList: any, role: string, accessLevel: string) => {
    const config: any = {};
    if (!configList) {
      return;
    }
    configList.forEach((conf: any) => {
      if (!config[conf["config_optn_grp_name"]]) {
        config[conf["config_optn_grp_name"]] = {};
      }
      config[conf["config_optn_grp_name"]][conf["config_optn_name"]] = JSON.parse(conf["config_optn_val"]);
    });
    config["role"] = role;

    set(() => ({ config: config, accessLevel }));
    const NavigationConfig = JSON.parse(configList.find((option : any) => option.config_optn_key === 'navigation')?.config_optn_val || '{}');
    const isMemberListPresent : boolean = _.find(_.get(NavigationConfig, 'optionValues', []), { value: 'member' })?.show;
    set(() => ({ isMemberListPresent : isMemberListPresent }));
  },
  clearStore: () => {
    set(() => ({ config: null }));
  },
});

export const useConfigStore = create(store);
